/*
批量修改路由组件
 */
import React, { Component } from 'react';
import NavMenu from '../../components/navMenu/navMenu';
import HeaderMenu from '../../components/headerMenu/headerMenu';
import '../../assets/css/common.less';
import { Input, Select, Tabs, Button, Pagination, Checkbox, Radio, Message, Loading, Tooltip, Tag, Dialog } from 'element-react';
import '../../pages/batchUpdatePrice/batchUpdatePrice.less';
import { requests, getToken, loadZhuKeToken,getLoginShopInfo,messageShow ,systemConfig,getZkShopName,getTaoteShopName }  from '../../utils/http';
import MyLoading from '../../components/showLoading/showLoading';
import ShowWarn from '../../components/showWarn/showWarn';
import NewUserGuide from '../../components/newUserGuide/index.jsx';

class BatchUpdatePrice extends Component {
  constructor(props) {
    super(props);
    this.state = {
      shopList: [],
      selectShopId: "",
      selectShopName: "",
      selectPlatformType:"",
      productList: [],  //产品列表
      pageSize: 10,
      current: 1,
      total: 0,
      isLoading: false,
      priceType: 1,//价格计算方式
      decimalsTypeData: [{ value: '1', label: '保留角分' }, { value: '2', label: '四舍五入到角' }, { value: '3', label: '四舍五入到元' }],
      decimalsType: 0,
      tabIndex: "1",  //修改页面 索引
      productStatus: [{ value: "", label: "商品状态" }, { value: "published", label: "在售" }, { value: "nopublished", label: "下架" }],
      selectProductStatus: "",
      productTitle: "",
      isShowWarn: false,
      noData: false,
      checkAll: false,
      prefix: "",//前缀
      suffix: "",//后缀
      replaceWord: "",//被替换词
      changeWord: "",//修改后词
      delMun: false,//删除数字
      delPT: false,//删除标点符号
      delSpace: false,//删除空格
      salePercent: 100,//售卖价百分比
      addSalePrice: 0, //售卖价补价
      rulesPriceType: 2,    //误操作防范  1为 新价格不低于  2为新价格不低于原价的
      rulesPrice: "",         //新价格不低于  单位元
      rulesPercent: 100,        //新价格不低于原价的  单位百分比
      stockNum: 0,  //统一库存
      isSync: false,//是否同步商品
      syncTime: "",
      showErrorDialog: false,
      errorData: [],
      errorLen: "",
      successLen: ""


    };
  }
  componentDidMount() {
    
    setTimeout(() => {
      var zhukeToken = getToken();
      var that = this;
      if (zhukeToken != "")
        that.getData();
      else {
  
        setTimeout(() => {
          var zhukeTokenTwo = getToken();
          if (zhukeTokenTwo == "") {
            var hasZhukeLoginShopTokens = localStorage.getItem("hasZhukeLoginShopTokens") || null;
            //var hasZhukeLoginShopTokens = "";//测试。
            if (hasZhukeLoginShopTokens != null && hasZhukeLoginShopTokens != "" && hasZhukeLoginShopTokens != undefined) {
              loadZhuKeToken(hasZhukeLoginShopTokens);
  
              setTimeout(() => {
                var zhukeTokenThree = getToken();
                if (zhukeTokenThree != "")
                   that.getData()
                else
                  that.setState({ isShowWarn: true });
  
              }, 500);
            } else
              that.setState({ isShowWarn: true });
          } else
             that.getData()
        }, 500);
  
      }
    }, 500);
  }

  async getData() {
    var shopInfo = getLoginShopInfo();
    var that = this;
    this.setState({
      selectShopId: shopInfo.loginShopId,
      selectShopName: shopInfo.loginShopName,
      selectPlatformType: shopInfo.loginShopPlatformType
    }, () => {
      that.loadProductList();
    })


    // let shopList = await this.loadShopList();
    // if (shopList.length == 0) {
    //   this.setState({
    //     isShowWarn: true,
    //     isSync: false
    //   })
    //   return;
    // }
    // this.setState({
    //   shopList: shopList,
    //   selectShopId: shopList[0].Id,
    // }, async () => {

    //   this.setState({
    //     pageSize:  this.state.pageSize,
    //     current: 1,
    //   }, () => {
    //     this.loadProductList();
    //   })


    //   //this.loadProductList();
    //   // //获取同步商品状态
    //   // let syncTime = await this.getSyncData();  //获取同步状态;
    //   // if (syncTime == "") { //为空时，说明没有同步好
    //   //   this.setState({
    //   //     isSync: true
    //   //   })
    //   //   this.reGetSyncStatus();//继续获取同步时间
    //   // } else {
    //   //   this.setState({
    //   //     syncTime,
    //   //     isSync: false
    //   //   })
    //   // }

    // })
  }


  // getSyncTimeAndSyncProduct=async () => {
  //    //获取同步商品状态
  //     let syncTime = await this.getSyncData();  //获取同步状态;
  //     if (syncTime == "") { //为空时，说明没有同步好
  //       this.setState({
  //         isSync: true
  //       })
  //       this.reGetSyncStatus();//继续获取同步时间
  //     } else {
  //       this.setState({
  //         syncTime,
  //         isSync: false
  //       })
  //     }
  // }

  // reGetSyncStatus = async () => {
  //   let getSyncDataTimer = null;
  //   let syncTime = await this.getSyncData();
  //   if (syncTime == "") {
  //     getSyncDataTimer = setTimeout(() => {  //1.5秒后再重新调一下
  //       this.reGetSyncStatus();
  //     }, 3000)
  //   } else {
  //     this.setState({
  //       isSync: false,
  //       syncTime
  //     })
  //   }
  // }

  // loadShopList() {  //获取店铺列表
  //   let data = { PlatformType: "TouTiao" };
  //   return new Promise((resolve, reject) => {
  //     requests({
  //       url: "/MyShop/SimpleList",
  //       data: data,
  //       success: (json) => {
  //         if (json.Success) {
  //           let shopList = this.state.shops;
  //           shopList = json.Data.DataList.Shops.filter((item) => { return item.PlatformType == "TouTiao" });
  //           resolve(shopList);
  //         } else {
  //           this.setState({
  //             isShowWarn: true
  //           })
  //           Message({
  //             showClose: true,
  //             message: json.Message,
  //             type: 'error'
  //           });
  //         }
  //       },
  //       fail: (err) => { }
  //     })
  //   })
  // }



   //同步商品方法
   syncProductClick() {
    var shopByLists = [this.state.selectShopId];
    var data = { ShopIdList: shopByLists }
    

    this.setState({isSync:true ,sysncStatusTaskProgress: 0 });
    var that = this;
    requests({
        url: "/Product/SyncProduct",
        data: data,
        success: function (res) {
            if (res.Success) {
                setTimeout(() => {
                    that.changeSyncProccess();
                }, 1000)
            } else {
                messageShow("同步错误：" + res.Message,"error");
                that.setState({ sysncStatusTaskProgress: 0 });
            }
        },
    });
    
  }
  //更新同步进度
  changeSyncProccess() {
    var that = this;
    var data = {
        ShopIds: [this.state.selectShopId],
        SyncType: 2,
        PlatformType: this.state.selectPlatformType
    }

    requests({
        url: "/Common/GetSyncStatusProccess",
        data: data,
        success: function (res) {
            if (res.Success) {
                if (res.Data == 100) {
                    that.setState({isSync:false, sysncStatusTaskProgress: res.Data });
                    that.shopLastSyncTime();
                } else {
                    that.setState({ sysncStatusTaskProgress: res.Data });
                    setTimeout(() => { that.changeSyncProccess(); }, 1000);
                }
            } else {
                // messageShow("同步错误：" + res.Message,"error");
                // that.setState({ sysncStatusTaskProgress: 0 });
            }
        },
    });

  }

  //获取店铺最后同步时间
  shopLastSyncTime() {
    var that = this;
    var data = {
        ShopIds: [this.state.selectShopId],
        SyncType: 2,
        PlatformType: this.state.selectPlatformType
    }

    requests({
        url: "/Common/GetLastSyncTime",
        data: data,
        success: function (res) {
            if (res.Success) {
                that.setState({ syncTime: res.Data });
            } else {
                // messageShow("同步错误：" + res.Message,"error");
                // that.setState({ sysncStatusTaskProgress: 0 });
            }
        },
    });

  }

  async loadProductList(isTrue) {
    if(this.state.isShowWarn){
      Message({ message: '检测到未授权【铺货代发】应用，请授权！', offset: 60, type: "warning" });
      return;
    }


    var that=this;
    let data = {};
    data.ShopPt = this.state.selectPlatformType;
    data.ShopId = this.state.selectShopId;

    if (isTrue) {
      this.setState({
        current:1
      })
      data.PageIndex = 1;
    } else {
      data.PageIndex = this.state.current;
    }

    if(data.PageIndex ==1){
      setTimeout(() => {
        //获取同步商品状态
        //that.getSyncTimeAndSyncProduct();
        this.syncProductClick();
      }, 600);
    }
   

    data.PageSize = this.state.pageSize;
    data.ProductTitle = this.state.productTitle;
    data.ProductStatus = this.state.selectProductStatus;
    this.setState({ isLoading: true, checkAll: false });

    requests({
      url: "/Product/List",
      data: data,
      success: (json) => {
        this.setState({ isLoading: false })
        if (json.Success) {
          let productList = json.Data.ProductList;
          for (let i = 0; i < productList.length; i++) {  //selectProductStatus获取sku价格，以后sku最低价格赋给产品
            if (productList[i].Skus && productList[i].Skus.length > 0) {
              productList[i].IsSelect = false;   //编辑商品信息用到
              productList[i].AfterSubject = "";  //修改后标题
              productList[i].isSuperWord = false; //是否超过60个字符

              let minPrice = productList[i].Skus[0].SalePrice;
              for (let j = 0; j < productList[i].Skus.length; j++) {
                let curPrice = productList[i].Skus[j].SalePrice;
                curPrice < minPrice ? minPrice = curPrice : null
              }
              productList[i].minPrice = minPrice;
              productList[i].AfterPrice = "";//改后价格
              productList[i].StockNum = "";//库存

            }
          }
          this.setState({
            productList,
            total: json.Data.TotalCount,
            noData: productList.length == 0 ? true : false
          })
        } else {
          Message({
            showClose: true,
            message: json.Message,
            type: 'error'
          });
        }
      },
      fail: (err) => { }
    })
  }

  changeCurrent = (current) => {
    this.setState({
      current,
      checkAll: false
    }, () => {
      this.loadProductList();
    })
  }
  changePageSize = (size) => {
    this.setState({
      pageSize: size,
      current: 1,
    }, () => {
      this.loadProductList();
    })
  }

  changeNav = (name) => {
    this.props.history.replace(name)
  }
  changeShopSelect = (name, value) => {
    this.setState({
      [name]: value,
      current: 1,
      selectProductStatus: "",
      productTitle: ""
    }, () => {
      this.loadProductList();
    })
  }
  changeSelect = (name, value) => {
    this.setState({
      [name]: value
    })
  }

  changeTabs = (obj) => {

    let productList = this.state.productList;
    productList.forEach((item, index) => {
      item.IsSelect = false;
      item.AfterSubject = "";
      item.AfterPrice = "";
      item.StockNum = "";
      item.isSuperWord = false;
    })

    let index = obj.props.name;
    this.setState({
      tabIndex: index,
      productList,
      checkAll: false
    })
  }

  onChangeInput = (name, value) => {
    let obj = {};
    obj[name] = value.trim();
    this.setState(obj);
  }
  onChangeCheck = (name, value) => {
    let obj = {};
    obj[name] = value;
    this.setState(obj);
  }
  resetSearch = () => {
    this.setState({
      selectProductStatus: "",
      productTitle: ""
    })
  }
  checkAllProduct = (isCheck) => {
    let productList = this.state.productList;
    productList.forEach((item, index) => {
      item.IsSelect = isCheck;
    })
    this.setState({
      productList,
      checkAll: isCheck
    })
  }
  checkItem = (id, value) => {
    let productList = this.state.productList;
    productList.forEach((item, index) => {
      if (item.Id == id) {
        item.IsSelect = value;
      }
    })
    this.setState({ productList })
  }

  changeAfterSubject = (id, value) => {  //修改单个标题
    let productList = this.state.productList;
    productList.forEach((item, index) => {
      if (item.Id == id) {
        item.AfterSubject = value;
        if (this.gblen(value) < 60) {
          item.isSuperWord = false;
        } else {
          item.isSuperWord = true;
          Message.error({
            message: '标记红色方框，商品标题已超过30个字',
            duration: 5000
          });
        }
      }
    })
    this.setState({
      productList
    })
  }

  changeAfterStock = (id, value) => {  //修改单个库存
    if (value != "") {
      var re = /^[0-9]+$/;//如：
      if (re.test(value) === false) {
        Message.error('请输入整数');
        return;
      }
    }
    let productList = this.state.productList;
    productList.forEach((item, index) => {
      if (item.Id == id) {
        item.StockNum = value
      }
    })
    this.setState({
      productList
    })

  }

  //计算字符串长度(英文占1个字符，中文汉字占2个字符)
  gblen = (str) => {
    var len = 0;
    for (var i = 0; i < str.length; i++) {
      if (str.charCodeAt(i) > 127 || str.charCodeAt(i) == 94) {
        len += 2;
      } else {
        len++;
      }
    }
    return len;
  }

  changeRuleInput = (name, value) => {
    if (value != "") {
      if (name == "salePercent" || name == "addSalePrice" || name == "rulesPrice" || name == "rulesPercent") {
        let re = /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/;
        if (re.test(value) == false) {
          if (name == "salePercent" || name == "rulesPercent") {
            this.setState({
              [name]: 100
            })
          } else if (name == "addSalePrice" || name == "rulesPrice") {
            this.setState({
              [name]: 0
            })
          }
          Message.error('请输入正数');
          return;
        } else {

        }
      }
    }
    this.setState({
      [name]: value
    })
  }

  changeStockNum = (name, value) => {
    if (value != "") {
      let re = /^[0-9]+$/;//如：
      if (re.test(value) == false) {
        Message.error('请输入整数');
        return;
      } else {
        this.setState({
          [name]: value
        })
      }
    }
  }


  changeRuleRadio = (name, value) => {
    this.setState({
      [name]: value
    })
  }

  changeDecimalsSelect = (name, value) => {
    this.setState({
      [name]: value
    })

  }

  syncProduct = () => {
    if(this.state.isShowWarn){
      Message({ message: '检测到未授权【铺货代发】应用，请授权！', offset: 60, type: "warning" });
      return;
    }


    this.setState({
      isSync: true,
      current: 1
    }, () => {
      this.loadProductList();
    })

  }

  previewData = () => {  //预览  
    let productList = this.state.productList;
    let prefix = this.state.prefix;
    let suffix = this.state.suffix;
    let isAlert = false;
    let replaceWord = this.state.replaceWord;
    let changeWord = this.state.changeWord;
    let delMun = this.state.delMun;
    let delPT = this.state.delPT;
    let delSpace = this.state.delSpace;
    let salePercent = this.state.salePercent;
    let addSalePrice = this.state.addSalePrice;
    let rulesPriceType = this.state.rulesPriceType;
    let rulesPrice = this.state.rulesPrice;
    let rulesPercent = this.state.rulesPercent;
    let decimalsType = this.state.decimalsType;
    let stockNum = this.state.stockNum;
    let tabIndex = this.state.tabIndex;
    let hasSelect = false;

    productList.forEach((item, index) => {
      item.AfterSubject = "";
      item.AfterPrice = "";
      item.StockNum = "";
      item.isSuperWord = false;

      if (item.IsSelect) {
        if (replaceWord != "") { //替换关键词
          item.AfterSubject = prefix + item.Subject.replace(new RegExp(replaceWord, 'gm'), changeWord) + suffix;
        } else {
          item.AfterSubject = prefix + item.Subject + suffix;
        }
        if (delMun) { //删除数字
          item.AfterSubject = item.AfterSubject.replace(/[0-9]/ig, "");
        }
        if (delPT) { //去掉标点符号
          item.AfterSubject = item.AfterSubject.replace(/[\ |\~|\`|\!|\@|\#|\$|\%|\^|\&|\*|\(|\)|\-|\_|\+|\=|\||\\|\[|\]|\{|\}|\;|\:|\"|\'|\,|\<|\.|\>|\/|\?/\，/\。/\；/\：/\“/\”/\》/\《/\|/\{/\}/\、/\!/\~/\`]/g, "")
        }
        if (delSpace) {      //去掉所有空格
          item.AfterSubject = item.AfterSubject.replace(/\s/g, "");
        }
        item.AfterPrice = ((item.minPrice - 0) * salePercent / 100 + (addSalePrice - 0)).toFixed(2);

        // if (rulesPriceType == 1) {    //误操作防范  1为 新价格不低于  2为新价格不低于原价的
        //   if ((item.AfterPrice - 0) < (rulesPrice - 0)) {
        //     item.AfterPrice = rulesPrice;
        //   }
        // } else if (rulesPriceType == 2) {
        //   if ((item.AfterPrice - 0) < (item.AfterPrice - 0) * rulesPercent / 100) {
        //     item.AfterPrice = (item.minPrice - 0) * rulesPercent / 100;
        //   }
        // }

        if (decimalsType == 1) {
          item.AfterPrice = (item.AfterPrice - 0).toFixed(2);//保留角分
        } else if (decimalsType == 2) {
          item.AfterPrice = (item.AfterPrice - 0).toFixed(1);//四舍五入到角
        } else if (decimalsType == 3) {
          item.AfterPrice = (item.AfterPrice - 0).toFixed(0)
        }
        item.StockNum = stockNum;
        item.AfterSubject = item.AfterSubject;
        item.isSuperWord = this.gblen(item.AfterSubject) > 60 ? true : false;
        if (item.isSuperWord) {
          isAlert = item.isSuperWord  //超过60个字的，输入框出现红框
        }
        hasSelect = true;
      }
    })

    this.setState({
      productList
    })

    if (isAlert && tabIndex == 1) {
      Message.error({
        message: '标记红色方框，商品标题已超过30个字',
        duration: 5000
      });
    }

    if (!hasSelect) {
      Message({
        type: 'warning',
        message: '请选择商品',
        duration: 5000
      });
    }
  }

  // getSyncData = () => {   //获取同步状态

  //   var data = {
  //     ShopIds: [this.state.selectShopId],
  //     SyncType: 2,
  //     PlatformType: this.state.selectPlatformType
  //  }


  //   return new Promise((resolve, reject) => {
  //     requests({
  //       url: "/Common/GetSyncStatusProccess",
  //       data: data,
  //       success: (json) => {
  //         console.log(json)
  //         if (json.Success) {
  //           resolve(res.Data);
  //         } else {
  //           Message({
  //             showClose: true,
  //             message: "同步商品：" + json.Message,
  //             type: 'error'
  //           });
  //         }
  //       },
  //       fail: (err) => { }
  //     })
  //   })
  // }

  cancelPreview = () => {
    let productList = this.state.productList;
    productList.forEach((item, index) => {
      item.AfterSubject = "";
      item.AfterPrice = "";
      item.StockNum = "";
      item.isSuperWord = false;
      item.IsSelect = false;

    })

    this.setState({
      productList,
      checkAll: false
    })

  }
  submitData = () => {
    let productList = this.state.productList;
    let tabIndex = this.state.tabIndex;
    let ProductList = [];
    let selectShopId = this.state.selectShopId;
    let updatePriceIds = [];
    let hasSelect = false;
    productList.forEach((item, index) => {
      if (item.IsSelect) {
        let obj = {};
        obj.ProductId = item.PlatformId;
        obj.ProductName = item.AfterSubject;
        ProductList.push(obj);
        updatePriceIds.push(item.PlatformId);
        hasSelect = true;
      }
    })

    if (!hasSelect) {
      Message({
        type: 'warning',
        message: '请选择商品',
        duration: 5000
      });
      return;
    }

    let url = "";
    let data = {};
    data.TargetShopId = selectShopId;
    if (tabIndex == 1) {  //保存修改标题
      let hasNull = false;
      ProductList.forEach((item, index) => {
        if (item.ProductName.trim() == "") {
          hasNull = true;
        }
      })
      if (hasNull) {
        Message({
          showClose: true,
          message: "商品标标题不能为空",
          type: 'error'
        });
        return;
      }
      url = "/ProductQuality/ProductEdit";
      data.ProductList = ProductList;
    } else if (tabIndex == 2) {  //修改价格
      data.ProductIdList = updatePriceIds;
      data.NewPriceLowest = this.state.rulesPriceType == 1 ? this.state.rulesPrice != "" ? this.state.rulesPrice : 0 : 0;
      data.NewPriceLowestRatio = this.state.rulesPriceType == 2 ? this.state.rulesPercent != "" ? this.state.rulesPercent : 0 : 0;
      data.SalePriceRatio = this.state.salePercent;
      data.AddToPrice = this.state.addSalePrice;
      url = "/ProductQuality/ProductUpdatePrice";

    } else if (tabIndex == 3) {
      data.ProductIdList = updatePriceIds;
      data.StocksNumber = this.state.stockNum;
      url = "/ProductQuality/ProductStock";
    }


    var productNumber=ProductList.length;
    if(tabIndex==2 || tabIndex ==3)
        productNumber=updatePriceIds.length;

    this.setState({
      isLoading: true
    })
    requests({
      url: url,
      data: data,
      success: (json) => {
        this.setState({ isLoading: false })
        if (json.Success) {
          if (json.Data.ErrorList && json.Data.ErrorList.length > 0) {
            let getErrorData = json.Data.ErrorList;
            let errorLen = getErrorData.length;   //失败条数
            let successLen = productNumber - getErrorData.length; //成功条数
            let errorData = [];
            productList.forEach((item, index) => {
              getErrorData.forEach((erItem, index02) => {
                if (item.PlatformId == erItem.ProductId && item.IsSelect) {
                  let obj = {};
                  obj.Subject = item.Subject;
                  obj.ErrorMessgage = erItem.ErrorMessgage
                  errorData.push(obj);
                }
              })
            })

            this.setState({
              errorData,
              showErrorDialog: true,
              errorLen,
              successLen
            })


          } else {
            Message({
              message: '成功，修改成功！',
              type: 'success'
            });
            this.cancelPreview();
          }
        } else {
          Message({
            showClose: true,
            message: json.Message,
            type: 'error'
          });
        }
      },
      fail: (err) => {

      }
    })
  }

  

  render() {
    let { priceType, decimalsType, tabIndex, shopList, selectShopId, productList, pageSize, current, total, isLoading, productStatus,
      isShowWarn, noData, productTitle, selectProductStatus, rulesPercent, rulesPrice, delMun, delPT, delSpace, salePercent, addSalePrice,
      rulesPriceType, decimalsTypeData, stockNum, isSync, syncTime, showErrorDialog, errorData, errorLen, successLen } = this.state;
    return (
      <div className='wrap'>
        <HeaderMenu />
        <main>
          <div className='wrap-left scroll-x' >
            <NavMenu changeNav={this.changeNav} defaultActive={"/batchUpdatePrice"} />
          </div>
          <div className="wrap-right main">
          <ShowWarn isShow={this.state.isShowWarn} targetUrl={this.changeNav} 
                                    from_action={systemConfig.zhukeAlibabaAuth === false ? 'alibaba_auth_expire' : systemConfig.zhukeTaoteAuth === false ? 'taote_auth_expire' :null} 
                                    alibabaNickName={getZkShopName()} taoteNickName={getTaoteShopName()}/>
             

            <div className='mywrap changeShopWrap'>
            <label className='changeShopWrap-label'>
              <span className='titleStyle'>当前店铺：{this.state.selectShopName}</span>
              {/* <Select value={selectShopId} clearable={true} style={{ width: "350px" }} onChange={this.changeShopSelect.bind(this, "selectShopId")}	>
                {
                  shopList.map(el => {
                    return <Select.Option key={el.Id} label={el.ShopName} value={el.Id} />
                  })
                }
              </Select> */}
            </label>
            <Tag type="gray" style={{ height: "30px", lineHeight: "30px" }}>
              <i className='tagIcon'>!</i>在操作前请先
              {
                !isSync ?
                  <span>点击按钮：<em onClick={() => this.syncProduct()}>同步后台商品</em>（最近同步时间：<s>{syncTime}</s>），待商品更新至最新再操作。</span> :
                  <span><em style={{ color: "#48576a" }}>同步后台商品</em>，正在在同步后台商品中<i className="el-icon-loading"></i></span>
              }
              
            </Tag>
          </div>
          <div className='mywrap'>
            <Tabs type="card" value="1" onTabClick={this.changeTabs.bind(this)}>
              <Tabs.Pane label="修改标题" name="1"></Tabs.Pane>
              <Tabs.Pane label="修改价格" name="2"></Tabs.Pane>
              <Tabs.Pane label="修改库存" name="3"></Tabs.Pane>
            </Tabs>
          </div>
          <div className='mywrap'>
            <div className='searchWrap'>
              <label className='titleStyle'>筛选：</label>
              <Select onChange={this.changeSelect.bind(this, "selectProductStatus")} value={selectProductStatus} clearable={true} style={{ width: "200px", marginRight: "10px" }}	>
                {
                  productStatus.map((el) => {
                    return <Select.Option key={el.value} label={el.label} value={el.value} />
                  })
                }
              </Select>
              <Input value={productTitle} onChange={this.onChangeInput.bind(this, "productTitle")} style={{ width: "200px", marginRight: "15px" }} placeholder='请输入商品名称' />
              <Button type="primary" onClick={() => this.loadProductList(true)}>搜索</Button>
              <Button onClick={() => this.resetSearch()}>重置</Button>
            </div>

            <div className="tableWrap">
              <table class="table-style01">
                <thead>
                  <tr>
                    <th style={{ width: "100px" }}>
                      <Checkbox checked={this.state.checkAll} onChange={this.checkAllProduct.bind(this)}></Checkbox>全选
                    </th>
                    <th style={{ minWidth: "430px" }}>原商品信息</th>
                    {
                      tabIndex == 1 ?
                        <th style={{ minWidth: "430px" }}>修改后（预览）</th> : null
                    }
                    {
                      tabIndex == 2 ?
                        <th style={{ minWidth: "215px" }}>价格 - 修改前</th> : null
                    }
                    {
                      tabIndex == 2 ?
                        <th style={{ minWidth: "215px" }}>价格-修改后（预览）</th> : null
                    }
                    {/* {
                      tabIndex == 3 ?
                        <th style={{ minWidth: "215px" }}>库存 - 修改前</th> : null
                    } */}
                    {
                      tabIndex == 3 ?
                        <th style={{ minWidth: "215px" }}>库存-修改后（预览）</th> : null
                    }
                  </tr>
                </thead>
                <tbody>

                  {
                    productList.map((item, index) =>
                      <tr>
                        <td style={{ paddingLeft: "38px" }}>
                          <Checkbox value={item.Id} checked={item.IsSelect} onChange={this.checkItem.bind(this, item.Id)}></Checkbox>
                        </td>
                        <td>
                          <div className='productWrap'>
                            <img src={item.ImageUrl} />
                            <span className='productWrap-title'>{item.Subject}</span>
                          </div>
                        </td>
                        {
                          tabIndex == 1 ?

                            item.IsSelect ?
                              item.isSuperWord ?
                                <td><Input style={{ border: "1px solid #ff4949" }} value={item.AfterSubject} onChange={this.changeAfterSubject.bind(this, item.Id)} /></td> : <td><Input value={item.AfterSubject} onChange={this.changeAfterSubject.bind(this, item.Id)} /></td>
                              :
                              <td><Input disabled value={""} /></td> :
                            null

                        }
                        {
                          tabIndex == 2 ?
                            <td style={{ textAlign: "center" }}>{item.minPrice}</td> : null
                        }
                        {
                          tabIndex == 2 ?
                            item.IsSelect ?
                              <td style={{ textAlign: "center", color: "#20A0FF" }}>{item.AfterPrice}</td> :
                              <td></td> : null

                        }
                        {/* {
                          tabIndex == 3 ?
                            <td style={{ textAlign: "center" }}>100</td> : null
                        } */}
                        {
                          tabIndex == 3 ?
                            item.IsSelect ? <td style={{ textAlign: "center", color: "#20A0FF" }}>{item.StockNum}</td> : <td></td>
                            // item.IsSelect ? <td><Input disabled value={item.StockNum} onChange={this.changeAfterStock.bind(this, item.Id)} /></td> : <td><Input disabled value={""} /></td>
                            : null
                        }
                      </tr>

                    )
                  }
                  {
                    noData ?
                      <tr className='table-noData'>
                        <td colSpan={20}><i className='el-icon-search'></i><span className='noData-title'>暂无数据！</span></td>
                      </tr> : null
                  }


                </tbody>
              </table>
              <div className="paginationWrap">
                {/* <Pagination onCurrentChange={this.changeCurrent.bind(this)} onSizeChange={this.changePageSize.bind(this)} layout="total, sizes, prev, pager, next, jumper" total={total} pageSizes={[10, 20, 50, 100]} pageSize={pageSize} currentPage={current} /> */}
                <Pagination onCurrentChange={this.changeCurrent.bind(this)} onSizeChange={this.changePageSize.bind(this)} layout="total,sizes,prev, pager, next" total={total} pageSize={pageSize} currentPage={current} pageSizes={[10]} />
              </div>
            </div>
          </div>
          <div className='mywrap'>

            <ul className='operateWrap' style={{ display: `${tabIndex == 1 ? "flex" : "none"}` }}>
              <li className='operateWrap-item'>
                <span className='operateWrap-title'>添加前后缀：</span>
                <div className='operateWrap-main'>
                  <label>
                    <span className='operateWrap-main-title'>前缀</span>
                    <Input size="small" style={{ flex: 1 }} onChange={this.onChangeInput.bind(this, "prefix")} />
                  </label>
                  <label>
                    <span className='operateWrap-main-title'>后缀</span>
                    <Input size="small" style={{ flex: 1 }} onChange={this.onChangeInput.bind(this, "suffix")} />
                  </label>
                </div>
              </li>
              <li className='operateWrap-item'>
                <span className='operateWrap-title'>替换关键词：</span>
                <div className='operateWrap-main'>
                  <label>
                    <span className='operateWrap-main-title'>输入词语</span>
                    <Input size="small" style={{ flex: 1 }} onChange={this.onChangeInput.bind(this, "replaceWord")} />
                  </label>
                  <label>
                    <span className='operateWrap-main-title'>修改成</span>
                    <Input size="small" style={{ flex: 1 }} onChange={this.onChangeInput.bind(this, "changeWord")} />
                  </label>
                  <label style={{ color: "#f7ba2a" }}>(不输入就是删除该词语)</label>
                </div>
              </li>
              <li className='operateWrap-item'>
                <span className='operateWrap-title'>删除特殊符号：</span>
                <div className='operateWrap-main'>
                  <label className='lastlabel'>
                    <Checkbox checked={delMun} onChange={this.onChangeCheck.bind(this, "delMun")}></Checkbox>
                    <span>数字</span>
                  </label>
                  <label className='lastlabel'>
                    <Checkbox checked={delPT} onChange={this.onChangeCheck.bind(this, "delPT")}></Checkbox>
                    <span>标点符号</span>
                  </label>
                  <label className='lastlabel'>
                    <Checkbox checked={delSpace} onChange={this.onChangeCheck.bind(this, "delSpace")}></Checkbox>
                    <span>空格</span>
                  </label>
                </div>
              </li>
            </ul>

            <ul className='operateWrap' style={{ display: `${tabIndex == 2 ? "flex" : "none"}` }}>
              {/* <li className='operateWrap-item'>
                <div>
                  <Radio value="1" checked={priceType == 1} onChange={this.onChangeInput.bind(this, "priceType")}>
                    统一售价：
                    <Input style={{ width: "150px" }} append="元" />
                  </Radio>
                </div>
              </li> */}

              <li className='operateWrap-item'>
                <div>
                  {/* <Radio value="2" checked={priceType == 2} onChange={this.onChangeInput.bind(this, "priceType")}></Radio> */}

                  <span className='operateWrap-title' style={{ textAlign: "right" }}>公式修改：</span>
                  <span style={{ color: "#1f2d3d", fontSize: "12px" }}>售卖价<i style={{ padding: "0 8px" }}>x</i></span>
                  <Input value={salePercent} onChange={this.changeRuleInput.bind(this, "salePercent")} size="small" style={{ width: "90px" }} append="%" />
                  <i style={{ padding: "0 8px" }}>+</i>
                  <Input value={addSalePrice} onChange={this.changeRuleInput.bind(this, "addSalePrice")} size="small" style={{ width: "90px" }} append="元" />
                </div>
              </li>
              <li className='operateWrap-item' style={{ alignItems: "flex-start", paddingBottom: 0 }}>
                <span className='operateWrap-title' style={{ textAlign: "right", paddingTop: "5px" }}>误操作防范：</span>
                <div className='operateWrap-main operateWrap-mainTwo'>
                  <div>
                    <Radio value="1" checked={rulesPriceType == 1} onChange={this.changeRuleRadio.bind(this, "rulesPriceType")}><span>新价格不低于</span></Radio>
                    <Tooltip className="item" effect="dark" content="比如：输入10，当新价格低于10元时，则使新价格调整为10元。" placement="right">
                      <Input value={rulesPrice} onChange={this.changeRuleInput.bind(this, "rulesPrice")} size="small" style={{ width: "145px" }} append="元" />
                    </Tooltip>
                  </div>
                  <div>
                    <Radio value="2" checked={rulesPriceType == 2} onChange={this.changeRuleRadio.bind(this, "rulesPriceType")}><span>新价格不低于原价的</span></Radio>
                    <Tooltip className="item" effect="dark" content="比如：输入200，当新价格低于原来的2倍时，则新价格调整为原来的2倍。" placement="right">
                      <Input value={rulesPercent} onChange={this.changeRuleInput.bind(this, "rulesPercent")} size="small" style={{ width: "102px" }} append="%" />
                    </Tooltip>
                  </div>
                </div>
              </li>
              <li className='operateWrap-item'>
                <div>
                  <span className='operateWrap-title02'>抹零设置：</span>
                  <Select size="small" value={decimalsType} clearable={true} style={{ width: "270px" }} onChange={this.changeDecimalsSelect.bind(this, "decimalsType")}	>
                    {
                      decimalsTypeData.map(el => {
                        return <Select.Option key={el.value} label={el.label} value={el.value} />
                      })
                    }
                  </Select>
                </div>
              </li>
            </ul>

            <ul className='operateWrap' style={{ display: `${tabIndex == 3 ? "flex" : "none"}` }}>
              <li className='operateWrap-item'>
                <span className='operateWrap-title'>统一库存：</span>
                <div className='operateWrap-main'>
                  <Input value={stockNum} onChange={this.changeStockNum.bind(this, "stockNum")} style={{ width: "150px" }} />
                </div>
              </li>
              {/* 
              <li className='operateWrap-item'>
                <span className='operateWrap-title'>统一阶梯库存：</span>
                <div className='operateWrap-main'>
                  <Input style={{ width: "150px" }} />
                  <span style={{ color: "#f7ba2a", fontSize: "12px", paddingLeft: "15px" }}>(当商品选择阶梯发货时才可设置阶梯库存)</span>
                </div>
              </li> */}
            </ul>
          </div>
          <div className='footerBtns'>
            <Button type="success" style={{ width: "120px" }} onClick={() => this.previewData()}>预览</Button>
            <Button type="primary" style={{ width: "120px" }} onClick={() => this.submitData()}>保存</Button>
            <Button type="danger" style={{ width: "120px" }} onClick={() => this.cancelPreview()}>取消</Button>
          </div>
           
          </div>
        </main>




        <Dialog title="提示" size="tiny" visible={showErrorDialog} style={{ width: "700px" }} onCancel={ () => this.setState({ showErrorDialog: false }) }>
          <Dialog.Body>
            <div className='errorDailog'>
              <div className='errorDailog-main'>
                <div className='errorDailog-main-up'>
                  <i className='el-icon-warning'></i>
                  修改任务已提交，成功：<i style={{ color: "#13CE66" }}>{successLen}</i>，失败：<i style={{ color: "#ff4949", marginRight: "15px" }}>{errorLen}</i>失败详情如下：
                </div>

                <div className='errorDailog-main-down'>
                  <table class="table-style01" >
                    <thead>
                      <tr>
                        <th style={{ width: "300px" }}>商品名称</th>
                        <th style={{ width: "350px" }}>原因原因</th>
                      </tr>
                    </thead>
                    <tbody>
                      {
                        errorData.map((item,index) =>
                          <tr>
                            <td>{item.Subject}</td>
                            <td>{item.ErrorMessgage}</td>
                          </tr>
                        )
                      }
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </Dialog.Body>
          <Dialog.Footer className="dialog-footer">
            <Button onClick={() => this.setState({ showErrorDialog: false })}>取消</Button>
            <Button type="primary" onClick={() => this.setState({ showErrorDialog: false })}>确定</Button>
          </Dialog.Footer>
        </Dialog>

        <MyLoading isLoading={this.state.isLoading} isStopOperate={true} fullCenter={true} />
        <NewUserGuide></NewUserGuide>
      </div>

    )
  }
}

export default BatchUpdatePrice;


// WEBPACK FOOTER //
// ./src/pages/batchUpdatePrice/batchUpdatePrice.jsx